import { END_POINTS } from '@config';
import { api } from '@core/baseApi';
import { HTTPResponse, OrgBranchMemberIds } from '@types';

import { CreateMemberRequest, UpdateMemberRequest } from '../types';

const extendedBaseQuery = api.injectEndpoints({
  endpoints: (builder) => ({
    createMember: builder.mutation<HTTPResponse<any>, CreateMemberRequest>({
      query: (req) => ({
        url: END_POINTS.MEMBER_MANAGEMENT.CREATE_MEMBER(req.params),
        method: 'POST',
        body: req.body
      })
    }),
    updateUserProfile: builder.mutation<HTTPResponse<any>, UpdateMemberRequest>(
      {
        query: (req) => ({
          url: END_POINTS.MEMBER_MANAGEMENT.UPDATE_MEMBER(req.params),
          method: 'POST',
          body: req.body
        })
      }
    ),
    getMemberDetails: builder.query<HTTPResponse<any>, OrgBranchMemberIds>({
      query: ({ organizationId, branchId, memberId }) => ({
        url: `${END_POINTS.MEMBER_MANAGEMENT.GET_MEMBER_DETAILS({
          organizationId,
          branchId,
          memberId
        })}`,
        method: 'GET'
      })
    }),
    getMembers: builder.query<
      HTTPResponse<any>,
      { organizationId: string; branchId: string; queryString: string }
    >({
      query: ({ organizationId, branchId, queryString }) => ({
        url: `${END_POINTS.MEMBER_MANAGEMENT.GET_MEMBERS({
          organizationId,
          branchId
        })}${queryString}`,
        method: 'GET'
      })
    }),
    getMemberCount: builder.mutation<
      HTTPResponse<any>,
      {
        organizationId: string;
        branchId: string;
        body: {
          group_ids: string[];
          include_non_group_members: boolean;
        };
      }
    >({
      query: ({ organizationId, branchId, body }) => ({
        url: `${END_POINTS.MEMBER_MANAGEMENT.GET_MEMBER_COUNT({
          organizationId,
          branchId
        })}`,
        method: 'POST',
        body
      })
    }),
    deleteMember: builder.mutation<HTTPResponse<any>, OrgBranchMemberIds>({
      query: ({ organizationId, branchId, memberId }) => ({
        url: END_POINTS.MEMBER_MANAGEMENT.DELETE_MEMBER({
          organizationId,
          branchId,
          memberId
        }),
        method: 'DELETE'
      })
    })
  })
});

export const {
  useCreateMemberMutation,
  useLazyGetMemberDetailsQuery,
  useLazyGetMembersQuery,
  useGetMemberDetailsQuery,
  useGetMemberCountMutation,
  useUpdateUserProfileMutation,
  useDeleteMemberMutation
} = extendedBaseQuery;
